import React from "react";
import { Link } from "react-router-dom";
import FeelingBored from "./FeelingBored/FeelingBored";
import { ReduxState } from "./ReduxState/ReduxState";
import { TodoComp } from "./Todo/TodoComp";
import { VirusTotalAPI } from "./VirusTotal/VirusTotalAPI";
import myName from "./myName.png";

export default function Home() {
  return (
    <div
      style={{
        padding: "1rem",
        margin: "1rem",
        marginLeft:"7%",
        marginRight:"7%"
        // backgroundImage: `url(${myName})`,
        // backgroundRepeat: "no-repeat",
        // backgroundPosition: "center",
      }}
    >
      <div
        style={{
          width: "100%",
          display: "flex",

          flexDirection: "column",
          //   flexWrap: "wrap",
          margin: "auto",
          // borderLeft: "solid 3px",
          padding: "1rem",
        }}
      >
        <div
          className="keyconcepts-div"
          style={{ display: "flex", flexWrap: "wrap", marginBottom: "1rem" }}
        >
          <div className="h6-width">
            <h6 style={{ padding: "2rem", textAlign: "justify" }}>
              React is an open-source JavaScript library for building user
              interfaces and It is declarative and fast. React team realized
              that JavaScript is fast, but updating the DOM makes it slow. So,
              they come up with the Virtual DOM. Virtual DOM is an in-memory representation
              of real DOM, Whenever states are changed new virtual DOM will be
              created and will be compared with previous virtual DOM which helps
              to find the changes (diff) and it is less expensive to apply only
              specific changes to the Real DOM. <br /> There are lot of concepts
              which can be really useful in working with React.
            </h6>
          </div>
          <div
            style={{
              textAlign: "center",
              margin: "auto",
            }}
          >
            <Link style={{ textDecoration: "none" }} to="/keyconcepts">
              <span
                style={{
                  alignContent: "left",
                  backgroundColor: "royalblue",
                  margin: "0.5rem",
                  padding: "0.8rem",

                  borderRadius: "1rem",
                  color: "white",
                }}
              >
                Read Key Concepts
              </span>
              {/* <div style={{ margin: "80px" }}></div> */}
            </Link>
          </div>
        </div>
        <div
          className="hooks-div"
          style={{ display: "flex", flexWrap: "wrap", marginBottom: "1rem" }}
        >
          <div className="h6-width">
            <h6 style={{ padding: "1rem", textAlign: "justify" }}>
              React Hooks made react much more simpler. Hooks are functions that
              let us “hook into” React state and lifecycle features in
              functional components.
            </h6>
          </div>
          <div
            style={{
              textAlign: "center",
              margin: "auto",
            }}
          >
            <Link style={{ textDecoration: "none" }} to="/hooks">
              <span
                style={{
                  backgroundColor: "royalblue",
                  margin: "0.5rem",
                  padding: "0.8rem",
                  borderRadius: "1rem",
                  color: "white",
                }}
              >
                Read Hooks
              </span>
            </Link>
          </div>
          {/* <div style={{ margin: "15vh" }}></div> */}
        </div>

        <div
          className="redux-div"
          style={{ display: "flex", flexWrap: "wrap", marginBottom: "1rem" }}
        >
          <div className="h6-width">
            <h6 style={{ padding: "1rem", textAlign: "justify" }}>
              Redux is a predictable state container for JavaScript Apps. It
              reduces the complexity of managing different states of the
              components when the app gets larger and it provides the ability to
              maintain the state of different components efficiently.
              <br />
              Redux works on three principles
              <li>Single State Object</li>
              <li>State is read-only</li>
              <li>Changes are made only through pure functions/reducers</li>
            </h6>
          </div>

          <div
            style={{
              textAlign: "center",
              margin: "auto",
            }}
          >
            <Link style={{ textDecoration: "none" }} to="/redux">
              <span
                style={{
                  backgroundColor: "royalblue",
                  margin: "0.5rem",
                  padding: "0.8rem",
                  borderRadius: "1rem",
                  color: "white",
                }}
              >
                Read Redux
              </span>
            </Link>
          </div>
          {/* <div style={{ margin: "15vh" }}></div> */}
        </div>
      </div>

      <FeelingBored />
    </div>
  );
}
